import React from 'react';
import { useDispatch } from 'react-redux';
import { CommonButton, ScreenContainer } from '../../CommonComponents';
import {
  syncCities, syncClients, syncProducts, syncStates, syncSuppliers,
} from '../../redux/actions/common';

const SyncData = () => {
  const dispatch = useDispatch();
  return (
    <ScreenContainer title="Sync Data from ROMS">
      <h3 className="mb-4">
        <b>Note :-</b>
        {' '}
        Please always sync clients before sync products
      </h3>
      <div className="row">
        <div className="col-sm-3 mb-3">
          <CommonButton
            variant="contained"
            color="primary"
            onClick={() => dispatch(syncClients())}
          >
            Sync Clients
          </CommonButton>
        </div>
        <div className="col-sm-3 mb-3">
          <CommonButton
            variant="contained"
            color="primary"
            onClick={() => dispatch(syncProducts())}
          >
            Sync Products
          </CommonButton>
        </div>
        <div className="col-sm-3 mb-3">
          <CommonButton
            variant="contained"
            color="primary"
            onClick={() => dispatch(syncSuppliers())}
          >
            Sync Suppliers
          </CommonButton>
        </div>
        <div className="col-sm-3 mb-3">
          <CommonButton
            variant="contained"
            color="primary"
            onClick={() => dispatch(syncStates())}
          >
            Sync States
          </CommonButton>
        </div>
        <div className="col-sm-3 mb-3">
          <CommonButton
            variant="contained"
            color="primary"
            onClick={() => dispatch(syncCities())}
          >
            Sync Cities
          </CommonButton>
        </div>
      </div>
    </ScreenContainer>
  )
}
export default SyncData;
